import React, { useState, useEffect } from 'react';
import './contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { BsInstagram, BsWhatsapp } from 'react-icons/bs';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';

const Contact = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "content"));
        if (!querySnapshot.empty) {
          // Pulls the first (and only) document in the content collection
          setContent(querySnapshot.docs[0].data());
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching contact data:", error);
        setLoading(false);
      }
    };

    fetchContactData();
  }, []);

  if (loading || !content) return null;

  return (
    <section id='contact'>
      <div className='contact1'>
        <div className='contact_header'>Contact Me</div>
        <div className='contact__options'>
          
          {/* EMAIL OPTION */}
          <article className="contact__option">
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            {/* Dynamic Email from Firestore */}
            <h5>{content.email}</h5>
            <a href={`mailto:${content.email}`} target='_blank' rel="noreferrer" style={{color:"#551A8B"}}>
              Send me an Email
            </a>
          </article>

          {/* INSTAGRAM OPTION */}
          <article className="contact__option">
            <BsInstagram className='contact__option-icon'/>
            <h4>Instagram</h4>
            {/* Dynamic Instagram Handle */}
            <h5>@{content.instagram}</h5>
            <a href={`https://www.instagram.com/${content.instagram}/`} target='_blank' rel="noreferrer">
              Find me on Instagram
            </a>
          </article>

          {/* WHATSAPP OPTION */}
          <article className="contact__option">
            <BsWhatsapp className='contact__option-icon'/>
            <h4>Whatsapp</h4>
            {/* Dynamic Contact Number */}
            <h5>+{content.contact_number}</h5>
            <a href={`https://wa.me/${content.contact_number}`} target='_blank' rel="noreferrer">
              Send me a Message here
            </a>
          </article>

        </div>
      </div>
    </section>
  );
}

export default Contact;